export const getDialogConfig = (type) => {
  const configs = {
    menu: {
      title: "Menu",
      fields: [
        {
          name: "nome",
          label: "Nome do Menu",
          type: "text",
          required: true,
          placeholder: "Ex: Bebidas, Comidas",
        },
        {
          name: "icone",
          label: "Icone",
          type: "file",
          required: false,
          placeholder: "Icone",
        },
        {
          name: "ordem",
          label: "Ordem",
          type: "number",
          placeholder: "1",
          required: true,
        },
      ],
    },
    group: {
      title: "Agrupamento",
      fields: [
        {
          name: "nome",
          label: "Nome do Agrupamento",
          type: "text",
          required: true,
          placeholder: "Ex: Cervejas, Petiscos",
        },
        {
          name: "ordem",
          label: "Ordem",
          type: "number",
          placeholder: "1",
          required: true,
        },
      ],
    },
    item: {
      title: "Item do Cardápio",
      fields: [
        {
          name: "codigo_produto",
          label: "Código do Produto",
          type: "text",
          required: true,
          placeholder: "Código do produto",
        },
        {
          name: "ordem",
          label: "Ordem",
          type: "number",
          placeholder: "1",
          required: true,
        },
      ],
    },
  }

  return configs[type];
};